"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.array.iterator.js");
require("core-js/modules/web.dom.iterable.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.number.constructor.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _Handle = _interopRequireDefault(require("./Handle"));
var _constants = require("./constants");
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/RangeSlider.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_95fc22v1g() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/RangeSlider.js";
  var hash = "019351d8dede53ba5bddae1b12e5067344fa3f1f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/RangeSlider.js",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "2": {
        start: {
          line: 43,
          column: 14
        },
        end: {
          line: 78,
          column: 1
        }
      },
      "3": {
        start: {
          line: 60,
          column: 37
        },
        end: {
          line: 60,
          column: 93
        }
      },
      "4": {
        start: {
          line: 80,
          column: 18
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "5": {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 81,
          column: 22
        }
      },
      "6": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 82,
          column: 21
        }
      },
      "7": {
        start: {
          line: 85,
          column: 16
        },
        end: {
          line: 85,
          column: 24
        }
      },
      "8": {
        start: {
          line: 100,
          column: 22
        },
        end: {
          line: 100,
          column: 93
        }
      },
      "9": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "10": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 104,
          column: 8
        }
      },
      "11": {
        start: {
          line: 103,
          column: 42
        },
        end: {
          line: 103,
          column: 95
        }
      },
      "12": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 16
        }
      },
      "13": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 17
        }
      },
      "14": {
        start: {
          line: 112,
          column: 33
        },
        end: {
          line: 112,
          column: 43
        }
      },
      "15": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 118,
          column: 6
        }
      },
      "16": {
        start: {
          line: 114,
          column: 37
        },
        end: {
          line: 114,
          column: 70
        }
      },
      "17": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 23
        }
      },
      "18": {
        start: {
          line: 122,
          column: 18
        },
        end: {
          line: 128,
          column: 3
        }
      },
      "19": {
        start: {
          line: 123,
          column: 22
        },
        end: {
          line: 123,
          column: 49
        }
      },
      "20": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 127,
          column: 7
        }
      },
      "21": {
        start: {
          line: 130,
          column: 27
        },
        end: {
          line: 132,
          column: 3
        }
      },
      "22": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 36
        }
      },
      "23": {
        start: {
          line: 134,
          column: 18
        },
        end: {
          line: 136,
          column: 3
        }
      },
      "24": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 27
        }
      },
      "25": {
        start: {
          line: 138,
          column: 25
        },
        end: {
          line: 147,
          column: 3
        }
      },
      "26": {
        start: {
          line: 139,
          column: 17
        },
        end: {
          line: 139,
          column: 65
        }
      },
      "27": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 146,
          column: 6
        }
      },
      "28": {
        start: {
          line: 149,
          column: 21
        },
        end: {
          line: 157,
          column: 3
        }
      },
      "29": {
        start: {
          line: 150,
          column: 26
        },
        end: {
          line: 150,
          column: 36
        }
      },
      "30": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 156,
          column: 10
        }
      },
      "31": {
        start: {
          line: 153,
          column: 25
        },
        end: {
          line: 153,
          column: 67
        }
      },
      "32": {
        start: {
          line: 154,
          column: 22
        },
        end: {
          line: 154,
          column: 71
        }
      },
      "33": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 53
        }
      },
      "34": {
        start: {
          line: 159,
          column: 19
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "35": {
        start: {
          line: 160,
          column: 23
        },
        end: {
          line: 160,
          column: 33
        }
      },
      "36": {
        start: {
          line: 161,
          column: 25
        },
        end: {
          line: 161,
          column: 35
        }
      },
      "37": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 167,
          column: 6
        }
      },
      "38": {
        start: {
          line: 170,
          column: 17
        },
        end: {
          line: 180,
          column: 3
        }
      },
      "39": {
        start: {
          line: 171,
          column: 26
        },
        end: {
          line: 171,
          column: 36
        }
      },
      "40": {
        start: {
          line: 172,
          column: 25
        },
        end: {
          line: 172,
          column: 35
        }
      },
      "41": {
        start: {
          line: 173,
          column: 27
        },
        end: {
          line: 173,
          column: 71
        }
      },
      "42": {
        start: {
          line: 174,
          column: 26
        },
        end: {
          line: 174,
          column: 95
        }
      },
      "43": {
        start: {
          line: 174,
          column: 57
        },
        end: {
          line: 174,
          column: 93
        }
      },
      "44": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 179,
          column: 6
        }
      },
      "45": {
        start: {
          line: 178,
          column: 39
        },
        end: {
          line: 178,
          column: 67
        }
      },
      "46": {
        start: {
          line: 182,
          column: 16
        },
        end: {
          line: 182,
          column: 72
        }
      },
      "47": {
        start: {
          line: 182,
          column: 37
        },
        end: {
          line: 182,
          column: 72
        }
      },
      "48": {
        start: {
          line: 184,
          column: 13
        },
        end: {
          line: 193,
          column: 3
        }
      },
      "49": {
        start: {
          line: 185,
          column: 20
        },
        end: {
          line: 185,
          column: 29
        }
      },
      "50": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 188,
          column: 5
        }
      },
      "51": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 17
        }
      },
      "52": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 191,
          column: 5
        }
      },
      "53": {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 190,
          column: 17
        }
      },
      "54": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 51
        }
      },
      "55": {
        start: {
          line: 198,
          column: 21
        },
        end: {
          line: 208,
          column: 3
        }
      },
      "56": {
        start: {
          line: 199,
          column: 26
        },
        end: {
          line: 199,
          column: 36
        }
      },
      "57": {
        start: {
          line: 200,
          column: 18
        },
        end: {
          line: 200,
          column: 32
        }
      },
      "58": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 203,
          column: 5
        }
      },
      "59": {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 202,
          column: 45
        }
      },
      "60": {
        start: {
          line: 204,
          column: 22
        },
        end: {
          line: 204,
          column: 40
        }
      },
      "61": {
        start: {
          line: 205,
          column: 22
        },
        end: {
          line: 205,
          column: 39
        }
      },
      "62": {
        start: {
          line: 207,
          column: 4
        },
        end: {
          line: 207,
          column: 61
        }
      },
      "63": {
        start: {
          line: 210,
          column: 17
        },
        end: {
          line: 210,
          column: 79
        }
      },
      "64": {
        start: {
          line: 210,
          column: 23
        },
        end: {
          line: 210,
          column: 79
        }
      },
      "65": {
        start: {
          line: 212,
          column: 24
        },
        end: {
          line: 216,
          column: 3
        }
      },
      "66": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 213,
          column: 35
        }
      },
      "67": {
        start: {
          line: 213,
          column: 26
        },
        end: {
          line: 213,
          column: 35
        }
      },
      "68": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 39
        }
      },
      "69": {
        start: {
          line: 224,
          column: 23
        },
        end: {
          line: 224,
          column: 99
        }
      },
      "70": {
        start: {
          line: 224,
          column: 44
        },
        end: {
          line: 224,
          column: 99
        }
      },
      "71": {
        start: {
          line: 228,
          column: 21
        },
        end: {
          line: 240,
          column: 3
        }
      },
      "72": {
        start: {
          line: 229,
          column: 44
        },
        end: {
          line: 229,
          column: 54
        }
      },
      "73": {
        start: {
          line: 230,
          column: 22
        },
        end: {
          line: 230,
          column: 49
        }
      },
      "74": {
        start: {
          line: 231,
          column: 29
        },
        end: {
          line: 231,
          column: 86
        }
      },
      "75": {
        start: {
          line: 233,
          column: 4
        },
        end: {
          line: 239,
          column: 6
        }
      },
      "76": {
        start: {
          line: 245,
          column: 12
        },
        end: {
          line: 252,
          column: 3
        }
      },
      "77": {
        start: {
          line: 246,
          column: 32
        },
        end: {
          line: 246,
          column: 42
        }
      },
      "78": {
        start: {
          line: 247,
          column: 22
        },
        end: {
          line: 247,
          column: 62
        }
      },
      "79": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 251,
          column: 7
        }
      },
      "80": {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 250,
          column: 45
        }
      },
      "81": {
        start: {
          line: 254,
          column: 20
        },
        end: {
          line: 256,
          column: 3
        }
      },
      "82": {
        start: {
          line: 255,
          column: 4
        },
        end: {
          line: 255,
          column: 47
        }
      },
      "83": {
        start: {
          line: 261,
          column: 16
        },
        end: {
          line: 273,
          column: 3
        }
      },
      "84": {
        start: {
          line: 264,
          column: 22
        },
        end: {
          line: 264,
          column: 49
        }
      },
      "85": {
        start: {
          line: 265,
          column: 28
        },
        end: {
          line: 265,
          column: 74
        }
      },
      "86": {
        start: {
          line: 266,
          column: 28
        },
        end: {
          line: 266,
          column: 58
        }
      },
      "87": {
        start: {
          line: 267,
          column: 21
        },
        end: {
          line: 267,
          column: 59
        }
      },
      "88": {
        start: {
          line: 270,
          column: 4
        },
        end: {
          line: 270,
          column: 74
        }
      },
      "89": {
        start: {
          line: 270,
          column: 50
        },
        end: {
          line: 270,
          column: 72
        }
      },
      "90": {
        start: {
          line: 272,
          column: 4
        },
        end: {
          line: 272,
          column: 26
        }
      },
      "91": {
        start: {
          line: 278,
          column: 13
        },
        end: {
          line: 288,
          column: 3
        }
      },
      "92": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 279,
          column: 24
        }
      },
      "93": {
        start: {
          line: 280,
          column: 4
        },
        end: {
          line: 280,
          column: 42
        }
      },
      "94": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 282,
          column: 66
        }
      },
      "95": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 67
        }
      },
      "96": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 76
        }
      },
      "97": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 285,
          column: 76
        }
      },
      "98": {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 287,
          column: 27
        }
      },
      "99": {
        start: {
          line: 293,
          column: 16
        },
        end: {
          line: 299,
          column: 3
        }
      },
      "100": {
        start: {
          line: 294,
          column: 34
        },
        end: {
          line: 294,
          column: 44
        }
      },
      "101": {
        start: {
          line: 295,
          column: 22
        },
        end: {
          line: 295,
          column: 49
        }
      },
      "102": {
        start: {
          line: 296,
          column: 28
        },
        end: {
          line: 296,
          column: 68
        }
      },
      "103": {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 298,
          column: 39
        }
      },
      "104": {
        start: {
          line: 304,
          column: 21
        },
        end: {
          line: 312,
          column: 3
        }
      },
      "105": {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 310,
          column: 5
        }
      },
      "106": {
        start: {
          line: 306,
          column: 31
        },
        end: {
          line: 306,
          column: 41
        }
      },
      "107": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 40
        }
      },
      "108": {
        start: {
          line: 308,
          column: 33
        },
        end: {
          line: 308,
          column: 40
        }
      },
      "109": {
        start: {
          line: 309,
          column: 6
        },
        end: {
          line: 309,
          column: 47
        }
      },
      "110": {
        start: {
          line: 311,
          column: 4
        },
        end: {
          line: 311,
          column: 18
        }
      },
      "111": {
        start: {
          line: 317,
          column: 20
        },
        end: {
          line: 325,
          column: 3
        }
      },
      "112": {
        start: {
          line: 318,
          column: 4
        },
        end: {
          line: 318,
          column: 24
        }
      },
      "113": {
        start: {
          line: 319,
          column: 4
        },
        end: {
          line: 319,
          column: 51
        }
      },
      "114": {
        start: {
          line: 321,
          column: 4
        },
        end: {
          line: 321,
          column: 73
        }
      },
      "115": {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 322,
          column: 63
        }
      },
      "116": {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 324,
          column: 18
        }
      },
      "117": {
        start: {
          line: 330,
          column: 21
        },
        end: {
          line: 345,
          column: 3
        }
      },
      "118": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 343,
          column: 5
        }
      },
      "119": {
        start: {
          line: 332,
          column: 31
        },
        end: {
          line: 332,
          column: 41
        }
      },
      "120": {
        start: {
          line: 333,
          column: 6
        },
        end: {
          line: 333,
          column: 40
        }
      },
      "121": {
        start: {
          line: 333,
          column: 33
        },
        end: {
          line: 333,
          column: 40
        }
      },
      "122": {
        start: {
          line: 335,
          column: 6
        },
        end: {
          line: 338,
          column: 7
        }
      },
      "123": {
        start: {
          line: 336,
          column: 8
        },
        end: {
          line: 336,
          column: 24
        }
      },
      "124": {
        start: {
          line: 337,
          column: 8
        },
        end: {
          line: 337,
          column: 15
        }
      },
      "125": {
        start: {
          line: 340,
          column: 20
        },
        end: {
          line: 340,
          column: 40
        }
      },
      "126": {
        start: {
          line: 342,
          column: 6
        },
        end: {
          line: 342,
          column: 53
        }
      },
      "127": {
        start: {
          line: 344,
          column: 4
        },
        end: {
          line: 344,
          column: 18
        }
      },
      "128": {
        start: {
          line: 350,
          column: 20
        },
        end: {
          line: 360,
          column: 3
        }
      },
      "129": {
        start: {
          line: 351,
          column: 4
        },
        end: {
          line: 351,
          column: 45
        }
      },
      "130": {
        start: {
          line: 351,
          column: 38
        },
        end: {
          line: 351,
          column: 45
        }
      },
      "131": {
        start: {
          line: 352,
          column: 4
        },
        end: {
          line: 352,
          column: 24
        }
      },
      "132": {
        start: {
          line: 354,
          column: 18
        },
        end: {
          line: 354,
          column: 38
        }
      },
      "133": {
        start: {
          line: 356,
          column: 4
        },
        end: {
          line: 356,
          column: 57
        }
      },
      "134": {
        start: {
          line: 358,
          column: 4
        },
        end: {
          line: 358,
          column: 73
        }
      },
      "135": {
        start: {
          line: 359,
          column: 4
        },
        end: {
          line: 359,
          column: 64
        }
      },
      "136": {
        start: {
          line: 363,
          column: 40
        },
        end: {
          line: 363,
          column: 50
        }
      },
      "137": {
        start: {
          line: 364,
          column: 25
        },
        end: {
          line: 364,
          column: 35
        }
      },
      "138": {
        start: {
          line: 365,
          column: 4
        },
        end: {
          line: 399,
          column: 6
        }
      },
      "139": {
        start: {
          line: 368,
          column: 10
        },
        end: {
          line: 368,
          column: 27
        }
      },
      "140": {
        start: {
          line: 373,
          column: 14
        },
        end: {
          line: 388,
          column: 16
        }
      },
      "141": {
        start: {
          line: 392,
          column: 12
        },
        end: {
          line: 394,
          column: 13
        }
      },
      "142": {
        start: {
          line: 393,
          column: 14
        },
        end: {
          line: 393,
          column: 26
        }
      },
      "143": {
        start: {
          line: 395,
          column: 12
        },
        end: {
          line: 395,
          column: 80
        }
      },
      "144": {
        start: {
          line: 403,
          column: 0
        },
        end: {
          line: 424,
          column: 2
        }
      },
      "145": {
        start: {
          line: 426,
          column: 0
        },
        end: {
          line: 437,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 60,
            column: 26
          },
          end: {
            line: 60,
            column: 27
          }
        },
        loc: {
          start: {
            line: 60,
            column: 37
          },
          end: {
            line: 60,
            column: 93
          }
        },
        line: 60
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 80,
            column: 18
          },
          end: {
            line: 80,
            column: 19
          }
        },
        loc: {
          start: {
            line: 80,
            column: 23
          },
          end: {
            line: 83,
            column: 1
          }
        },
        line: 80
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 85,
            column: 16
          },
          end: {
            line: 85,
            column: 17
          }
        },
        loc: {
          start: {
            line: 85,
            column: 22
          },
          end: {
            line: 85,
            column: 24
          }
        },
        line: 85
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 48
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 99
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 103,
            column: 33
          },
          end: {
            line: 103,
            column: 34
          }
        },
        loc: {
          start: {
            line: 103,
            column: 42
          },
          end: {
            line: 103,
            column: 95
          }
        },
        line: 103
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 21
          },
          end: {
            line: 120,
            column: 3
          }
        },
        line: 109
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 114,
            column: 28
          },
          end: {
            line: 114,
            column: 29
          }
        },
        loc: {
          start: {
            line: 114,
            column: 37
          },
          end: {
            line: 114,
            column: 70
          }
        },
        line: 114
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 122,
            column: 18
          },
          end: {
            line: 122,
            column: 19
          }
        },
        loc: {
          start: {
            line: 122,
            column: 24
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 122
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 130,
            column: 27
          },
          end: {
            line: 130,
            column: 28
          }
        },
        loc: {
          start: {
            line: 130,
            column: 35
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 130
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 134,
            column: 18
          },
          end: {
            line: 134,
            column: 19
          }
        },
        loc: {
          start: {
            line: 134,
            column: 26
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 134
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 138,
            column: 25
          },
          end: {
            line: 138,
            column: 26
          }
        },
        loc: {
          start: {
            line: 138,
            column: 31
          },
          end: {
            line: 147,
            column: 3
          }
        },
        line: 138
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 149,
            column: 21
          },
          end: {
            line: 149,
            column: 22
          }
        },
        loc: {
          start: {
            line: 149,
            column: 40
          },
          end: {
            line: 157,
            column: 3
          }
        },
        line: 149
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 152,
            column: 28
          },
          end: {
            line: 152,
            column: 29
          }
        },
        loc: {
          start: {
            line: 152,
            column: 55
          },
          end: {
            line: 156,
            column: 5
          }
        },
        line: 152
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 159,
            column: 19
          },
          end: {
            line: 159,
            column: 20
          }
        },
        loc: {
          start: {
            line: 159,
            column: 25
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 159
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 170,
            column: 17
          },
          end: {
            line: 170,
            column: 18
          }
        },
        loc: {
          start: {
            line: 170,
            column: 44
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 170
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 174,
            column: 40
          },
          end: {
            line: 174,
            column: 41
          }
        },
        loc: {
          start: {
            line: 174,
            column: 57
          },
          end: {
            line: 174,
            column: 93
          }
        },
        line: 174
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 178,
            column: 32
          },
          end: {
            line: 178,
            column: 33
          }
        },
        loc: {
          start: {
            line: 178,
            column: 39
          },
          end: {
            line: 178,
            column: 67
          }
        },
        line: 178
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 182,
            column: 16
          },
          end: {
            line: 182,
            column: 17
          }
        },
        loc: {
          start: {
            line: 182,
            column: 37
          },
          end: {
            line: 182,
            column: 72
          }
        },
        line: 182
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 184,
            column: 13
          },
          end: {
            line: 184,
            column: 14
          }
        },
        loc: {
          start: {
            line: 184,
            column: 32
          },
          end: {
            line: 193,
            column: 3
          }
        },
        line: 184
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 198,
            column: 21
          },
          end: {
            line: 198,
            column: 22
          }
        },
        loc: {
          start: {
            line: 198,
            column: 28
          },
          end: {
            line: 208,
            column: 3
          }
        },
        line: 198
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 210,
            column: 17
          },
          end: {
            line: 210,
            column: 18
          }
        },
        loc: {
          start: {
            line: 210,
            column: 23
          },
          end: {
            line: 210,
            column: 79
          }
        },
        line: 210
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 212,
            column: 24
          },
          end: {
            line: 212,
            column: 25
          }
        },
        loc: {
          start: {
            line: 212,
            column: 30
          },
          end: {
            line: 216,
            column: 3
          }
        },
        line: 212
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 224,
            column: 23
          },
          end: {
            line: 224,
            column: 24
          }
        },
        loc: {
          start: {
            line: 224,
            column: 44
          },
          end: {
            line: 224,
            column: 99
          }
        },
        line: 224
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 228,
            column: 21
          },
          end: {
            line: 228,
            column: 22
          }
        },
        loc: {
          start: {
            line: 228,
            column: 48
          },
          end: {
            line: 240,
            column: 3
          }
        },
        line: 228
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 245,
            column: 12
          },
          end: {
            line: 245,
            column: 13
          }
        },
        loc: {
          start: {
            line: 245,
            column: 39
          },
          end: {
            line: 252,
            column: 3
          }
        },
        line: 245
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 249,
            column: 29
          },
          end: {
            line: 249,
            column: 30
          }
        },
        loc: {
          start: {
            line: 249,
            column: 35
          },
          end: {
            line: 251,
            column: 5
          }
        },
        line: 249
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 254,
            column: 20
          },
          end: {
            line: 254,
            column: 21
          }
        },
        loc: {
          start: {
            line: 254,
            column: 26
          },
          end: {
            line: 256,
            column: 3
          }
        },
        line: 254
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 261,
            column: 16
          },
          end: {
            line: 261,
            column: 17
          }
        },
        loc: {
          start: {
            line: 261,
            column: 21
          },
          end: {
            line: 273,
            column: 3
          }
        },
        line: 261
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 270,
            column: 44
          },
          end: {
            line: 270,
            column: 45
          }
        },
        loc: {
          start: {
            line: 270,
            column: 50
          },
          end: {
            line: 270,
            column: 72
          }
        },
        line: 270
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 278,
            column: 13
          },
          end: {
            line: 278,
            column: 14
          }
        },
        loc: {
          start: {
            line: 278,
            column: 19
          },
          end: {
            line: 288,
            column: 3
          }
        },
        line: 278
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 293,
            column: 16
          },
          end: {
            line: 293,
            column: 17
          }
        },
        loc: {
          start: {
            line: 293,
            column: 26
          },
          end: {
            line: 299,
            column: 3
          }
        },
        line: 293
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 304,
            column: 21
          },
          end: {
            line: 304,
            column: 22
          }
        },
        loc: {
          start: {
            line: 304,
            column: 27
          },
          end: {
            line: 312,
            column: 3
          }
        },
        line: 304
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 317,
            column: 20
          },
          end: {
            line: 317,
            column: 21
          }
        },
        loc: {
          start: {
            line: 317,
            column: 26
          },
          end: {
            line: 325,
            column: 3
          }
        },
        line: 317
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 330,
            column: 21
          },
          end: {
            line: 330,
            column: 22
          }
        },
        loc: {
          start: {
            line: 330,
            column: 27
          },
          end: {
            line: 345,
            column: 3
          }
        },
        line: 330
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 350,
            column: 20
          },
          end: {
            line: 350,
            column: 21
          }
        },
        loc: {
          start: {
            line: 350,
            column: 26
          },
          end: {
            line: 360,
            column: 3
          }
        },
        line: 350
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 362,
            column: 2
          },
          end: {
            line: 362,
            column: 3
          }
        },
        loc: {
          start: {
            line: 362,
            column: 11
          },
          end: {
            line: 400,
            column: 3
          }
        },
        line: 362
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 367,
            column: 18
          },
          end: {
            line: 367,
            column: 19
          }
        },
        loc: {
          start: {
            line: 367,
            column: 26
          },
          end: {
            line: 369,
            column: 9
          }
        },
        line: 367
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 372,
            column: 27
          },
          end: {
            line: 372,
            column: 28
          }
        },
        loc: {
          start: {
            line: 373,
            column: 14
          },
          end: {
            line: 388,
            column: 16
          }
        },
        line: 373
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 391,
            column: 25
          },
          end: {
            line: 391,
            column: 26
          }
        },
        loc: {
          start: {
            line: 391,
            column: 45
          },
          end: {
            line: 396,
            column: 11
          }
        },
        line: 391
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 60,
            column: 37
          },
          end: {
            line: 60,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 37
          },
          end: {
            line: 60,
            column: 55
          }
        }, {
          start: {
            line: 60,
            column: 59
          },
          end: {
            line: 60,
            column: 93
          }
        }],
        line: 60
      },
      "1": {
        loc: {
          start: {
            line: 100,
            column: 22
          },
          end: {
            line: 100,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 66
          },
          end: {
            line: 100,
            column: 78
          }
        }, {
          start: {
            line: 100,
            column: 81
          },
          end: {
            line: 100,
            column: 93
          }
        }],
        line: 100
      },
      "2": {
        loc: {
          start: {
            line: 100,
            column: 22
          },
          end: {
            line: 100,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 22
          },
          end: {
            line: 100,
            column: 34
          }
        }, {
          start: {
            line: 100,
            column: 38
          },
          end: {
            line: 100,
            column: 63
          }
        }],
        line: 100
      },
      "3": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 101
      },
      "4": {
        loc: {
          start: {
            line: 141,
            column: 14
          },
          end: {
            line: 141,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 14
          },
          end: {
            line: 141,
            column: 25
          }
        }, {
          start: {
            line: 141,
            column: 29
          },
          end: {
            line: 141,
            column: 66
          }
        }],
        line: 141
      },
      "5": {
        loc: {
          start: {
            line: 145,
            column: 13
          },
          end: {
            line: 145,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 13
          },
          end: {
            line: 145,
            column: 23
          }
        }, {
          start: {
            line: 145,
            column: 27
          },
          end: {
            line: 145,
            column: 63
          }
        }],
        line: 145
      },
      "6": {
        loc: {
          start: {
            line: 155,
            column: 13
          },
          end: {
            line: 155,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 155,
            column: 36
          },
          end: {
            line: 155,
            column: 39
          }
        }, {
          start: {
            line: 155,
            column: 42
          },
          end: {
            line: 155,
            column: 52
          }
        }],
        line: 155
      },
      "7": {
        loc: {
          start: {
            line: 174,
            column: 57
          },
          end: {
            line: 174,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 73
          },
          end: {
            line: 174,
            column: 87
          }
        }, {
          start: {
            line: 174,
            column: 90
          },
          end: {
            line: 174,
            column: 93
          }
        }],
        line: 174
      },
      "8": {
        loc: {
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 188,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 4
          },
          end: {
            line: 188,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 186
      },
      "9": {
        loc: {
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 189
      },
      "10": {
        loc: {
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 201
      },
      "11": {
        loc: {
          start: {
            line: 213,
            column: 4
          },
          end: {
            line: 213,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 213,
            column: 4
          },
          end: {
            line: 213,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 213
      },
      "12": {
        loc: {
          start: {
            line: 236,
            column: 8
          },
          end: {
            line: 236,
            column: 95
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 236,
            column: 43
          },
          end: {
            line: 236,
            column: 80
          }
        }, {
          start: {
            line: 236,
            column: 83
          },
          end: {
            line: 236,
            column: 95
          }
        }],
        line: 236
      },
      "13": {
        loc: {
          start: {
            line: 238,
            column: 6
          },
          end: {
            line: 238,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 238,
            column: 41
          },
          end: {
            line: 238,
            column: 78
          }
        }, {
          start: {
            line: 238,
            column: 81
          },
          end: {
            line: 238,
            column: 94
          }
        }],
        line: 238
      },
      "14": {
        loc: {
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 310,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 310,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 305
      },
      "15": {
        loc: {
          start: {
            line: 308,
            column: 6
          },
          end: {
            line: 308,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 308,
            column: 6
          },
          end: {
            line: 308,
            column: 40
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 308
      },
      "16": {
        loc: {
          start: {
            line: 331,
            column: 4
          },
          end: {
            line: 343,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 331,
            column: 4
          },
          end: {
            line: 343,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 331
      },
      "17": {
        loc: {
          start: {
            line: 333,
            column: 6
          },
          end: {
            line: 333,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 333,
            column: 6
          },
          end: {
            line: 333,
            column: 40
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 333
      },
      "18": {
        loc: {
          start: {
            line: 335,
            column: 6
          },
          end: {
            line: 338,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 335,
            column: 6
          },
          end: {
            line: 338,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 335
      },
      "19": {
        loc: {
          start: {
            line: 351,
            column: 4
          },
          end: {
            line: 351,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 351,
            column: 4
          },
          end: {
            line: 351,
            column: 45
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 351
      },
      "20": {
        loc: {
          start: {
            line: 384,
            column: 29
          },
          end: {
            line: 384,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 384,
            column: 40
          },
          end: {
            line: 384,
            column: 47
          }
        }, {
          start: {
            line: 384,
            column: 50
          },
          end: {
            line: 384,
            column: 70
          }
        }],
        line: 384
      },
      "21": {
        loc: {
          start: {
            line: 385,
            column: 30
          },
          end: {
            line: 385,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 385,
            column: 41
          },
          end: {
            line: 385,
            column: 48
          }
        }, {
          start: {
            line: 385,
            column: 51
          },
          end: {
            line: 385,
            column: 71
          }
        }],
        line: 385
      },
      "22": {
        loc: {
          start: {
            line: 386,
            column: 27
          },
          end: {
            line: 386,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 386,
            column: 38
          },
          end: {
            line: 386,
            column: 45
          }
        }, {
          start: {
            line: 386,
            column: 48
          },
          end: {
            line: 386,
            column: 66
          }
        }],
        line: 386
      },
      "23": {
        loc: {
          start: {
            line: 387,
            column: 25
          },
          end: {
            line: 387,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 387,
            column: 36
          },
          end: {
            line: 387,
            column: 43
          }
        }, {
          start: {
            line: 387,
            column: 46
          },
          end: {
            line: 387,
            column: 60
          }
        }],
        line: 387
      },
      "24": {
        loc: {
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 394,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 394,
            column: 13
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 392
      },
      "25": {
        loc: {
          start: {
            line: 392,
            column: 16
          },
          end: {
            line: 392,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 392,
            column: 16
          },
          end: {
            line: 392,
            column: 25
          }
        }, {
          start: {
            line: 392,
            column: 29
          },
          end: {
            line: 392,
            column: 43
          }
        }],
        line: 392
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "019351d8dede53ba5bddae1b12e5067344fa3f1f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_95fc22v1g = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_95fc22v1g();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var RangeSliderWrapper = (cov_95fc22v1g().s[0]++, _styledComponents.default.div.attrs({
  className: 'g-RangeSlider-wrapper'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  text-align: left;\n"]))));
var SliderBackground = (cov_95fc22v1g().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-RangeSlider-SliderBackground"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      background-color: white;\n      border-radius: 4px;\n      background-repeat: repeat-x;\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n      cursor: pointer;\n      border: 1px solid lightgray;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      background-repeat: repeat-x;\n      cursor: pointer;\n      border: ", ";\n      border-radius: ", ";\n      box-shadow: none;\n      background-color: ", ";\n    "])), _themeMapper.evolutionTheme.priceRange.slider.border, _themeMapper.evolutionTheme.priceRange.slider.borderRadius, _themeMapper.evolutionTheme.priceRange.slider.bgColor))));
var Range = (cov_95fc22v1g().s[2]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-RangeSlider-sliderProgressBar"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      width: 50%;\n      position: absolute;\n      z-index: 1;\n      display: block;\n      background-position: 0 0;\n      height: 100%;\n      border-radius: 4px;\n      box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px inset;\n      -webkit-box-sizing: border-box;\n      -moz-box-sizing: border-box;\n      box-sizing: border-box;\n      background-color: ", ";\n    "])), function (props) {
  cov_95fc22v1g().f[0]++;
  cov_95fc22v1g().s[3]++;
  return (cov_95fc22v1g().b[0][0]++, props.theme.button) && (cov_95fc22v1g().b[0][1]++, props.theme.button.backgroundColor);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      width: 50%;\n      position: absolute;\n      z-index: 1;\n      display: block;\n      background-position: 0 0;\n      border-radius: 4px;\n      box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px inset;\n      -webkit-box-sizing: border-box;\n      -moz-box-sizing: border-box;\n      box-sizing: border-box;\n      height: 6px;\n      background-color: var(--primaryColor, #2f2b43);\n      top: 0;\n    "]))))));
cov_95fc22v1g().s[4]++;
var killEvent = function killEvent(e) {
  cov_95fc22v1g().f[1]++;
  cov_95fc22v1g().s[5]++;
  e.stopPropagation();
  cov_95fc22v1g().s[6]++;
  e.preventDefault();
};
cov_95fc22v1g().s[7]++;
var emptyFn = function emptyFn() {
  cov_95fc22v1g().f[2]++;
};

/**
 * The simple range slider component with min max value
 *
 * @class RangeSlider
 * @extends {Component}
 */
var RangeSlider = /*#__PURE__*/function (_Component) {
  function RangeSlider(props) {
    var _this;
    (0, _classCallCheck2.default)(this, RangeSlider);
    cov_95fc22v1g().f[5]++;
    cov_95fc22v1g().s[13]++;
    _this = _callSuper(this, RangeSlider, [props]);
    (0, _defineProperty2.default)(_this, "setStartSlide", (cov_95fc22v1g().s[18]++, function (ev) {
      cov_95fc22v1g().f[7]++;
      var sliderBox = (cov_95fc22v1g().s[19]++, _this.getSliderBoundingBox());
      cov_95fc22v1g().s[20]++;
      _this.setState({
        handleDimensions: _this.getHandleDimensions(ev, sliderBox),
        slidingIndex: _this.getHandleFor(ev)
      });
    }));
    (0, _defineProperty2.default)(_this, "setHandleContainerNode", (cov_95fc22v1g().s[21]++, function (node) {
      cov_95fc22v1g().f[8]++;
      cov_95fc22v1g().s[22]++;
      _this.handleContainerNode = node;
    }));
    (0, _defineProperty2.default)(_this, "setHandleNode", (cov_95fc22v1g().s[23]++, function (node) {
      cov_95fc22v1g().f[9]++;
      cov_95fc22v1g().s[24]++;
      _this.handleNode = node;
    }));
    (0, _defineProperty2.default)(_this, "getSliderBoundingBox", (cov_95fc22v1g().s[25]++, function () {
      cov_95fc22v1g().f[10]++;
      var rect = (cov_95fc22v1g().s[26]++, _this.handleContainerNode.getBoundingClientRect());
      cov_95fc22v1g().s[27]++;
      return {
        height: (cov_95fc22v1g().b[4][0]++, rect.height) || (cov_95fc22v1g().b[4][1]++, _this.handleContainerNode.clientHeight),
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: (cov_95fc22v1g().b[5][0]++, rect.width) || (cov_95fc22v1g().b[5][1]++, _this.handleContainerNode.clientWidth)
      };
    }));
    (0, _defineProperty2.default)(_this, "getClosestHandle", (cov_95fc22v1g().s[28]++, function (positionPercent) {
      cov_95fc22v1g().f[11]++;
      var _ref = (cov_95fc22v1g().s[29]++, _this.state),
        handlePos = _ref.handlePos;
      cov_95fc22v1g().s[30]++;
      return handlePos.reduce(function (closestIdx, node, idx) {
        cov_95fc22v1g().f[12]++;
        var challenger = (cov_95fc22v1g().s[31]++, Math.abs(handlePos[idx] - positionPercent));
        var current = (cov_95fc22v1g().s[32]++, Math.abs(handlePos[closestIdx] - positionPercent));
        cov_95fc22v1g().s[33]++;
        return challenger < current ? (cov_95fc22v1g().b[6][0]++, idx) : (cov_95fc22v1g().b[6][1]++, closestIdx);
      }, 0);
    }));
    (0, _defineProperty2.default)(_this, "getPublicState", (cov_95fc22v1g().s[34]++, function () {
      cov_95fc22v1g().f[13]++;
      var _ref2 = (cov_95fc22v1g().s[35]++, _this.state),
        values = _ref2.values;
      var _ref3 = (cov_95fc22v1g().s[36]++, _this.props),
        min = _ref3.min,
        max = _ref3.max;
      cov_95fc22v1g().s[37]++;
      return {
        max: max,
        min: min,
        values: values
      };
    }));
    (0, _defineProperty2.default)(_this, "getNextState", (cov_95fc22v1g().s[38]++, function (idx, proposedPosition) {
      cov_95fc22v1g().f[14]++;
      var _ref4 = (cov_95fc22v1g().s[39]++, _this.state),
        handlePos = _ref4.handlePos;
      var _ref5 = (cov_95fc22v1g().s[40]++, _this.props),
        max = _ref5.max,
        min = _ref5.min;
      var actualPosition = (cov_95fc22v1g().s[41]++, _this.validatePosition(idx, proposedPosition));
      var nextHandlePos = (cov_95fc22v1g().s[42]++, handlePos.map(function (pos, index) {
        cov_95fc22v1g().f[15]++;
        cov_95fc22v1g().s[43]++;
        return index === idx ? (cov_95fc22v1g().b[7][0]++, actualPosition) : (cov_95fc22v1g().b[7][1]++, pos);
      }));
      cov_95fc22v1g().s[44]++;
      return {
        handlePos: nextHandlePos,
        values: nextHandlePos.map(function (pos) {
          cov_95fc22v1g().f[16]++;
          cov_95fc22v1g().s[45]++;
          return _this.getValue(pos, min, max);
        })
      };
    }));
    (0, _defineProperty2.default)(_this, "getPosition", (cov_95fc22v1g().s[46]++, function (value, min, max) {
      cov_95fc22v1g().f[17]++;
      cov_95fc22v1g().s[47]++;
      return (value - min) / (max - min) * 100;
    }));
    (0, _defineProperty2.default)(_this, "getValue", (cov_95fc22v1g().s[48]++, function (pos, min, max) {
      cov_95fc22v1g().f[18]++;
      var decimal = (cov_95fc22v1g().s[49]++, pos / 100);
      cov_95fc22v1g().s[50]++;
      if (pos === 0) {
        cov_95fc22v1g().b[8][0]++;
        cov_95fc22v1g().s[51]++;
        return min;
      } else {
        cov_95fc22v1g().b[8][1]++;
      }
      cov_95fc22v1g().s[52]++;
      if (pos === 100) {
        cov_95fc22v1g().b[9][0]++;
        cov_95fc22v1g().s[53]++;
        return max;
      } else {
        cov_95fc22v1g().b[9][1]++;
      }
      cov_95fc22v1g().s[54]++;
      return Math.round((max - min) * decimal + min);
    }));
    /**
     * Produce the new style for updated handles
     */
    (0, _defineProperty2.default)(_this, "getProgressStyle", (cov_95fc22v1g().s[55]++, function (idx) {
      cov_95fc22v1g().f[19]++;
      var _ref6 = (cov_95fc22v1g().s[56]++, _this.state),
        handlePos = _ref6.handlePos;
      var value = (cov_95fc22v1g().s[57]++, handlePos[idx]);
      cov_95fc22v1g().s[58]++;
      if (idx === 0) {
        cov_95fc22v1g().b[10][0]++;
        cov_95fc22v1g().s[59]++;
        return {
          left: 0,
          width: "".concat(value, "%")
        };
      } else {
        cov_95fc22v1g().b[10][1]++;
      }
      var prevValue = (cov_95fc22v1g().s[60]++, handlePos[idx - 1]);
      var diffValue = (cov_95fc22v1g().s[61]++, value - prevValue);
      cov_95fc22v1g().s[62]++;
      return {
        left: "".concat(prevValue, "%"),
        width: "".concat(diffValue, "%")
      };
    }));
    (0, _defineProperty2.default)(_this, "getHandleFor", (cov_95fc22v1g().s[63]++, function (ev) {
      cov_95fc22v1g().f[20]++;
      cov_95fc22v1g().s[64]++;
      return Number(ev.currentTarget.getAttribute('data-handle-key'));
    }));
    (0, _defineProperty2.default)(_this, "getHandleDimensions", (cov_95fc22v1g().s[65]++, function () {
      cov_95fc22v1g().f[21]++;
      cov_95fc22v1g().s[66]++;
      if (!_this.handleNode) {
        cov_95fc22v1g().b[11][0]++;
        cov_95fc22v1g().s[67]++;
        return 0;
      } else {
        cov_95fc22v1g().b[11][1]++;
      }
      cov_95fc22v1g().s[68]++;
      return _this.handleNode.clientWidth;
    }));
    /**
     *  x: position for HORIZENTAL
     *  y: position for VERTICAL // TODO
     *  sliderBox: the container of slider
     * @returns: the position of provide x on range slider container in percent
     */
    (0, _defineProperty2.default)(_this, "getPositionPercent", (cov_95fc22v1g().s[69]++, function (x, y, sliderBox) {
      cov_95fc22v1g().f[22]++;
      cov_95fc22v1g().s[70]++;
      return (x - sliderBox.left) / sliderBox.width * _constants.PERCENT_FULL;
    }));
    // Make sure the proposed position respects the bounds and
    // does not collide with other handles too much.
    (0, _defineProperty2.default)(_this, "validatePosition", (cov_95fc22v1g().s[71]++, function (idx, proposedPosition) {
      cov_95fc22v1g().f[23]++;
      var _ref7 = (cov_95fc22v1g().s[72]++, _this.state),
        handlePos = _ref7.handlePos,
        handleDimensions = _ref7.handleDimensions;
      var sliderBox = (cov_95fc22v1g().s[73]++, _this.getSliderBoundingBox());
      var handlePercentage = (cov_95fc22v1g().s[74]++, handleDimensions / sliderBox.width * _constants.PERCENT_FULL / 2);
      cov_95fc22v1g().s[75]++;
      return Math.max(Math.min(proposedPosition, handlePos[idx + 1] !== undefined ? (cov_95fc22v1g().b[12][0]++, handlePos[idx + 1] - handlePercentage) : (cov_95fc22v1g().b[12][1]++, _constants.PERCENT_FULL) // 100% is the highest value
      ), handlePos[idx - 1] !== undefined ? (cov_95fc22v1g().b[13][0]++, handlePos[idx - 1] + handlePercentage) : (cov_95fc22v1g().b[13][1]++, _constants.PERCENT_EMPTY) // 0% is the lowest value
      );
    }));
    /**
     * Calculate next state of handles > re-render > handle will update style position
     */
    (0, _defineProperty2.default)(_this, "slideTo", (cov_95fc22v1g().s[76]++, function (idx, proposedPosition) {
      cov_95fc22v1g().f[24]++;
      var _ref8 = (cov_95fc22v1g().s[77]++, _this.props),
        onValuesUpdated = _ref8.onValuesUpdated;
      var nextState = (cov_95fc22v1g().s[78]++, _this.getNextState(idx, proposedPosition));
      cov_95fc22v1g().s[79]++;
      _this.setState(nextState, function () {
        cov_95fc22v1g().f[25]++;
        cov_95fc22v1g().s[80]++;
        onValuesUpdated(_this.getPublicState());
      });
    }));
    (0, _defineProperty2.default)(_this, "fireChangeEvent", (cov_95fc22v1g().s[81]++, function () {
      cov_95fc22v1g().f[26]++;
      cov_95fc22v1g().s[82]++;
      _this.props.onChange(_this.getPublicState());
    }));
    /**
     * Called when click on the slide container not the handles
     */
    (0, _defineProperty2.default)(_this, "handleClick", (cov_95fc22v1g().s[83]++, function (e) {
      cov_95fc22v1g().f[27]++;
      // Calculate the position of the slider on the page so we can determine
      // the position where you click in relativity.
      var sliderBox = (cov_95fc22v1g().s[84]++, _this.getSliderBoundingBox());
      var positionDecimal = (cov_95fc22v1g().s[85]++, (e.clientX - sliderBox.left) / sliderBox.width);
      var positionPercent = (cov_95fc22v1g().s[86]++, positionDecimal * _constants.PERCENT_FULL);
      var handleId = (cov_95fc22v1g().s[87]++, _this.getClosestHandle(positionPercent));

      // Move the handle there
      cov_95fc22v1g().s[88]++;
      _this.slideTo(handleId, positionPercent, function () {
        cov_95fc22v1g().f[28]++;
        cov_95fc22v1g().s[89]++;
        return _this.fireChangeEvent();
      });
      cov_95fc22v1g().s[90]++;
      _this.props.onClick(e);
    }));
    /**
     * Called on handles's mouse up
     */
    (0, _defineProperty2.default)(_this, "endSlide", (cov_95fc22v1g().s[91]++, function () {
      cov_95fc22v1g().f[29]++;
      cov_95fc22v1g().s[92]++;
      _this.mouseDown -= 1;
      cov_95fc22v1g().s[93]++;
      _this.setState({
        slidingIndex: null
      });
      cov_95fc22v1g().s[94]++;
      document.removeEventListener('mouseup', _this.endSlide, false);
      cov_95fc22v1g().s[95]++;
      document.removeEventListener('touchend', _this.endSlide, false);
      cov_95fc22v1g().s[96]++;
      document.removeEventListener('touchmove', _this.handleTouchSlide, false);
      cov_95fc22v1g().s[97]++;
      document.removeEventListener('mousemove', _this.handleMouseSlide, false);
      cov_95fc22v1g().s[98]++;
      _this.fireChangeEvent();
    }));
    /**
     * Handle to update the position of the handles
     */
    (0, _defineProperty2.default)(_this, "handleSlide", (cov_95fc22v1g().s[99]++, function (x, y) {
      cov_95fc22v1g().f[30]++;
      var _ref9 = (cov_95fc22v1g().s[100]++, _this.state),
        idx = _ref9.slidingIndex;
      var sliderBox = (cov_95fc22v1g().s[101]++, _this.getSliderBoundingBox());
      var positionPercent = (cov_95fc22v1g().s[102]++, _this.getPositionPercent(x, y, sliderBox));
      cov_95fc22v1g().s[103]++;
      _this.slideTo(idx, positionPercent);
    }));
    /**
     * called on mouse moving
     */
    (0, _defineProperty2.default)(_this, "handleMouseSlide", (cov_95fc22v1g().s[104]++, function (ev) {
      cov_95fc22v1g().f[31]++;
      cov_95fc22v1g().s[105]++;
      if (_this.mouseDown > 0) {
        cov_95fc22v1g().b[14][0]++;
        var _ref10 = (cov_95fc22v1g().s[106]++, _this.state),
          slidingIndex = _ref10.slidingIndex;
        cov_95fc22v1g().s[107]++;
        if (slidingIndex === null) {
          cov_95fc22v1g().b[15][0]++;
          cov_95fc22v1g().s[108]++;
          return;
        } else {
          cov_95fc22v1g().b[15][1]++;
        }
        cov_95fc22v1g().s[109]++;
        _this.handleSlide(ev.clientX, ev.clientY);
      } else {
        cov_95fc22v1g().b[14][1]++;
      }
      cov_95fc22v1g().s[110]++;
      killEvent(ev);
    }));
    /**
     * called on handles's mouse down
     */
    (0, _defineProperty2.default)(_this, "startMouseSlide", (cov_95fc22v1g().s[111]++, function (ev) {
      cov_95fc22v1g().f[32]++;
      cov_95fc22v1g().s[112]++;
      _this.mouseDown += 1;
      cov_95fc22v1g().s[113]++;
      _this.setStartSlide(ev, ev.clientX, ev.clientY);
      cov_95fc22v1g().s[114]++;
      document.addEventListener('mousemove', _this.handleMouseSlide, false);
      cov_95fc22v1g().s[115]++;
      document.addEventListener('mouseup', _this.endSlide, false);
      cov_95fc22v1g().s[116]++;
      killEvent(ev);
    }));
    /**
     * Handle sliding for mobile, tablet
     */
    (0, _defineProperty2.default)(_this, "handleTouchSlide", (cov_95fc22v1g().s[117]++, function (ev) {
      cov_95fc22v1g().f[33]++;
      cov_95fc22v1g().s[118]++;
      if (_this.mouseDown > 0) {
        cov_95fc22v1g().b[16][0]++;
        var _ref11 = (cov_95fc22v1g().s[119]++, _this.state),
          slidingIndex = _ref11.slidingIndex;
        cov_95fc22v1g().s[120]++;
        if (slidingIndex === null) {
          cov_95fc22v1g().b[17][0]++;
          cov_95fc22v1g().s[121]++;
          return;
        } else {
          cov_95fc22v1g().b[17][1]++;
        }
        cov_95fc22v1g().s[122]++;
        if (ev.changedTouches.length > 1) {
          cov_95fc22v1g().b[18][0]++;
          cov_95fc22v1g().s[123]++;
          _this.endSlide();
          cov_95fc22v1g().s[124]++;
          return;
        } else {
          cov_95fc22v1g().b[18][1]++;
        }
        var touch = (cov_95fc22v1g().s[125]++, ev.changedTouches[0]);
        cov_95fc22v1g().s[126]++;
        _this.handleSlide(touch.clientX, touch.clientY);
      } else {
        cov_95fc22v1g().b[16][1]++;
      }
      cov_95fc22v1g().s[127]++;
      killEvent(ev);
    }));
    /**
     * Handle sliding for mobile, tablet
     */
    (0, _defineProperty2.default)(_this, "startTouchSlide", (cov_95fc22v1g().s[128]++, function (ev) {
      cov_95fc22v1g().f[34]++;
      cov_95fc22v1g().s[129]++;
      if (ev.changedTouches.length > 1) {
        cov_95fc22v1g().b[19][0]++;
        cov_95fc22v1g().s[130]++;
        return;
      } else {
        cov_95fc22v1g().b[19][1]++;
      }
      cov_95fc22v1g().s[131]++;
      _this.mouseDown += 1;
      var touch = (cov_95fc22v1g().s[132]++, ev.changedTouches[0]);
      cov_95fc22v1g().s[133]++;
      _this.setStartSlide(ev, touch.clientX, touch.clientY);
      cov_95fc22v1g().s[134]++;
      document.addEventListener('touchmove', _this.handleTouchSlide, false);
      cov_95fc22v1g().s[135]++;
      document.addEventListener('touchend', _this.endSlide, false);
    }));
    var _ref12 = (cov_95fc22v1g().s[14]++, _this.props),
      _max = _ref12.max,
      _min = _ref12.min,
      _values = _ref12.values;
    cov_95fc22v1g().s[15]++;
    _this.state = {
      handlePos: _values.map(function (value) {
        cov_95fc22v1g().f[6]++;
        cov_95fc22v1g().s[16]++;
        return _this.getPosition(value, _min, _max);
      }),
      handleDimensions: 0,
      slidingIndex: null,
      values: _values
    };
    cov_95fc22v1g().s[17]++;
    _this.mouseDown = 0;
    return _this;
  }
  (0, _inherits2.default)(RangeSlider, _Component);
  return (0, _createClass2.default)(RangeSlider, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_95fc22v1g().f[35]++;
      var _ref13 = (cov_95fc22v1g().s[136]++, this.state),
        handlePos = _ref13.handlePos,
        slidingIndex = _ref13.slidingIndex;
      var _ref14 = (cov_95fc22v1g().s[137]++, this.props),
        disabled = _ref14.disabled;
      cov_95fc22v1g().s[138]++;
      return /*#__PURE__*/_react.default.createElement(RangeSliderWrapper, {
        innerRef: function innerRef(node) {
          cov_95fc22v1g().f[36]++;
          cov_95fc22v1g().s[139]++;
          _this2.node = node;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 366,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(SliderBackground, {
        onClick: this.handleClick,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 370,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: this.setHandleContainerNode,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 371,
          columnNumber: 11
        }
      }, handlePos.map(function (pos, idx) {
        cov_95fc22v1g().f[37]++;
        cov_95fc22v1g().s[140]++;
        return /*#__PURE__*/_react.default.createElement(_Handle.default
        /*
        * For smooth scrolling on mobile:
        * If we set key = uuid() method, when we setState in setStartSlide DOM nodes will be
        * removed and added multiple times while scrolling (touchmove event). In this case, we want
        * to have the same numbers of <Handle/> component so using index in this context is safe
        */, {
          isSliding: slidingIndex === idx,
          key: idx // eslint-disable-line react/no-array-index-key
          ,
          style: {
            left: "".concat(pos, "%"),
            position: 'absolute'
          },
          "data-handle-key": idx,
          onMouseDown: disabled ? (cov_95fc22v1g().b[20][0]++, emptyFn) : (cov_95fc22v1g().b[20][1]++, _this2.startMouseSlide),
          onTouchStart: disabled ? (cov_95fc22v1g().b[21][0]++, emptyFn) : (cov_95fc22v1g().b[21][1]++, _this2.startTouchSlide),
          handleRef: disabled ? (cov_95fc22v1g().b[22][0]++, emptyFn) : (cov_95fc22v1g().b[22][1]++, _this2.setHandleNode),
          onClick: disabled ? (cov_95fc22v1g().b[23][0]++, emptyFn) : (cov_95fc22v1g().b[23][1]++, _this2.killEvent),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 373,
            columnNumber: 15
          }
        });
      })), handlePos.map(function (node, idx, arr) {
        cov_95fc22v1g().f[38]++;
        cov_95fc22v1g().s[141]++;
        if ((cov_95fc22v1g().b[25][0]++, idx === 0) && (cov_95fc22v1g().b[25][1]++, arr.length > 1)) {
          cov_95fc22v1g().b[24][0]++;
          cov_95fc22v1g().s[142]++;
          return null;
        } else {
          cov_95fc22v1g().b[24][1]++;
        }
        cov_95fc22v1g().s[143]++;
        return /*#__PURE__*/_react.default.createElement(Range, {
          key: (0, _utils.uuid)(idx),
          style: _this2.getProgressStyle(idx),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 395,
            columnNumber: 20
          }
        });
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value:
    /**
     * Method to update the position of the range values
     * @param {*} props
     * @param {*} state
     */
    function getDerivedStateFromProps(props, state) {
      cov_95fc22v1g().f[3]++;
      var auxValues = (cov_95fc22v1g().s[8]++, (cov_95fc22v1g().b[2][0]++, props.values) && (cov_95fc22v1g().b[2][1]++, props.values.length === 2) ? (cov_95fc22v1g().b[1][0]++, props.values) : (cov_95fc22v1g().b[1][1]++, state.values));
      cov_95fc22v1g().s[9]++;
      if (props.values !== state.values) {
        cov_95fc22v1g().b[3][0]++;
        cov_95fc22v1g().s[10]++;
        return {
          handlePos: auxValues.map(function (value) {
            cov_95fc22v1g().f[4]++;
            cov_95fc22v1g().s[11]++;
            return (value - props.min) / (props.max - props.min) * 100;
          })
        };
      } else {
        cov_95fc22v1g().b[3][1]++;
      }
      cov_95fc22v1g().s[12]++;
      return null;
    }
  }]);
}(_react.Component);
cov_95fc22v1g().s[144]++;
RangeSlider.propTypes = {
  /** The minimum value of the slider */
  min: _propTypes.default.number,
  /** The maximum value of the slider */
  max: _propTypes.default.number,
  /** */
  values: _propTypes.default.arrayOf(_propTypes.default.number),
  /** 'horizontal' or 'vertical' */
  orientation: _propTypes.default.oneOf(['HORIZONTAL', 'VERTICAL']),
  /** If true, handles can't be moved. */
  disabled: _propTypes.default.bool,
  /** called on click */
  onClick: _propTypes.default.func,
  /** called whenever the user is done changing values on the slider */
  onChange: _propTypes.default.func,
  /** called when start sliding */
  onStartSlide: _propTypes.default.func,
  /** called after sliding done */
  onValuesUpdated: _propTypes.default.func,
  /** the custom handler, the idea is custom handles with tooltip etc */
  handles: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node])
};
cov_95fc22v1g().s[145]++;
RangeSlider.defaultProps = {
  min: 0,
  max: 100,
  values: [],
  orientation: _constants.HORIZONTAL,
  disabled: false,
  onClick: emptyFn,
  onChange: emptyFn,
  onStartSlide: emptyFn,
  onValuesUpdated: emptyFn,
  handles: null
};
var _default = exports.default = RangeSlider;